export type ConfigModel = {
  'base-urls': {
    [key: string]: Object;
  };
  invalidUserInputOnLink: {
    [key: string]: Object;
  };
  isOrcaEnabled: Boolean;
  'media-support': Object;
  validationFailedMessage: {
    [key: string]: Object;
  };
};
